import { render, staticRenderFns } from "./FacebookLive.vue?vue&type=template&id=9674a500&scoped=true&"
import script from "./FacebookLive.vue?vue&type=script&lang=js&"
export * from "./FacebookLive.vue?vue&type=script&lang=js&"
import style0 from "./FacebookLive.vue?vue&type=style&index=0&id=9674a500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9674a500",
  null
  
)

export default component.exports